import type { AnyAction, Dispatch } from 'redux';

import * as EquipmentUtilizationByCategoryTableAPI from 'ab-api/web/equipmentUtilization/findByCategoryTable';
import * as EquipmentUtilizationByGroupTableAPI from 'ab-api/web/equipmentUtilization/findByGroupTable';
import * as EquipmentUtilizationBySubCategoryTableAPI from 'ab-api/web/equipmentUtilization/findBySubCategoryTable';
import * as EquipmentUtilizationByTypeTableAPI from 'ab-api/web/equipmentUtilization/findByTypeTable';
import * as EquipmentUtilizationChartsAPI from 'ab-api/web/equipmentUtilization/findCharts';
import * as EquipmentUtilizationCompanyTableAPI from 'ab-api/web/equipmentUtilization/findCompanyTable';

import type { EquipmentCostCategory } from '@acceligentllc/shared/enums/equipmentCostCategory';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

export function fetchEquipmentUtilizationForCompanyTable() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<EquipmentUtilizationCompanyTableAPI.W_EquipmentUtilization_FindCompanyTable_VM>(EquipmentUtilizationCompanyTableAPI.URL());
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function fetchEquipmentUtilizationByTypeTable(type: EquipmentCostCategory, year: string) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<EquipmentUtilizationByTypeTableAPI.W_EquipmentUtilization_FindAllByTypeTable_VM>(
				EquipmentUtilizationByTypeTableAPI.URL(type, year)
			);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function fetchEquipmentUtilizationByGroupTable(groupId: number, year: string) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<EquipmentUtilizationByGroupTableAPI.W_EquipmentUtilization_FindByGroupTable_VM>(
				EquipmentUtilizationByGroupTableAPI.URL(groupId, year)
			);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function fetchEquipmentUtilizationByCategoryTable(categoryId: number, year: string) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<EquipmentUtilizationByCategoryTableAPI.W_EquipmentUtilization_FindByCategoryTable_VM>(
				EquipmentUtilizationByCategoryTableAPI.URL(categoryId, year)
			);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function fetchEquipmentUtilizationBySubCategoryTable(subCategoryId: number, year: string) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<EquipmentUtilizationBySubCategoryTableAPI.W_EquipmentUtilization_FindBySubCategoryTable_VM>(
				EquipmentUtilizationBySubCategoryTableAPI.URL(subCategoryId, year)
			);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function fetchEquipmentUtilizationCharts(subCategoryId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<EquipmentUtilizationChartsAPI.W_EquipmentUtilization_FindCharts_VM>(EquipmentUtilizationChartsAPI.URL(subCategoryId));
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

